import { motion } from "framer-motion";
import { IMAGES, T } from "../data/content";
import { useLang } from "../context/LangContext";

const Frame = ({ src, caption, alt, className, delay }) => (
  <motion.figure
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={`group relative overflow-hidden rounded-sm border border-white/10 ${className}`}
  >
    <img src={src} alt={alt} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
    <figcaption className="absolute bottom-4 left-4 text-[10px] uppercase tracking-[0.25em] text-[#F5ECDA]">{caption}</figcaption>
  </motion.figure>
);

export const Studio = () => {
  const { tr } = useLang();
  return (
    <section className="relative bg-[#15100B] py-24 lg:py-32" data-testid="studio-section">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="mb-14 max-w-2xl">
          <div className="mb-5 flex items-center gap-3">
            <span className="h-px w-10 bg-[#D4AF37]" />
            <span className="text-[10px] uppercase tracking-[0.4em] text-[#D4AF37]">{tr(T.studio.label)}</span>
          </div>
          <h2 className="font-serif text-5xl tracking-tight text-[#F5ECDA] md:text-6xl">{tr(T.studio.title)}</h2>
          <p className="mt-5 text-base leading-relaxed text-[#B7A78C]">{tr(T.studio.body)}</p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:auto-rows-[420px]">
          <Frame src={IMAGES.studio.storefront} alt="Slaly Hair & Beauty shopfront in Wallington" caption={tr(T.studio.cap_storefront)} className="md:row-span-1" delay={0} />
          <Frame src={IMAGES.studio.interior} alt="Slaly styling station" caption={tr(T.studio.cap_interior)} className="md:row-span-1" delay={0.1} />
          <Frame src={IMAGES.studio.street} alt="High Street Wallington" caption={tr(T.studio.cap_street)} className="md:row-span-1" delay={0.2} />
        </div>
      </div>
    </section>
  );
};
